<template>
  <div class="board-mb" >
    <div >
      <Row :gutter="10" justify="center">
        <Col  span="8">
          <div class="cus-data-mb">
            <div class="cus-data-title-mb cus-data-title-bg1-mb" >
              客户消费
            </div>
            <div class="cus-data-content-mb">
              <div class="cus-data-content-data-mb">
                <span class="data-span-mb">
                  稳定性评级:{{ boardData.payoutStabilityRating }}<br>
                  月均支出:<br>{{ homeStat.summary_metrics.payoutMonthAvg }}元<br>
                  近3个月均消费:<br>{{ boardData.payoutLastThreeMonths }}元<br>
                  近6个月均消费:<br>{{ boardData.payoutLastSixMonths }}元
                </span>
                <span class="data-span-mb" v-if="boardData.payoutLastThreeMonthsExpend != '-'">
                  近3个月微信消费:{{ boardData.payoutLastThreeMonthsExpend }}元<br>
                  近6个月微信消费:{{ boardData.payoutLastSixMonthsExpend }}元<br>
                </span>
              </div>
              <div class="cus-data-content-foot-mb" style="margin-top: 23pt;">
                <div class="cus-data-content-describe-mb">
                  提供客户消费能力与消费数据，依据客户日常消费数据（消费数据不包含红包/还款等数据），判断客户收入能力，近3个月和6个月不包括转账，稳定性分为高中/低依次变差，近3个月按照近90天，近6个月按照近180天取数，下同
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col  span="8">
          <div class="cus-data-mb">
            <div class="cus-data-title-mb cus-data-title-bg2-mb" >
              客户收入
            </div>
            <div class="cus-data-content-mb">
              <div class="cus-data-content-data-mb">
                <span class="data-span-mb">
                  稳定性评级：{{ boardData.incomeStabilityRating }}<br>
                  月均工资：<br> {{ homeStat.incoming.wages.monthAvg }}，{{ homeStat.incoming.wages.countData }}个月<br>
                  月均收单：<br>{{ homeStat.incoming.posTrade.monthAvg }}，{{ homeStat.incoming.posTrade.countData }}个月<br>
                  月均收入：<br>{{ homeStat.summary_metrics.incomingMonthAvg}}元<br>
                  近3个月均收入：<br>{{ boardData.incomeLastThreeMonths }}元<br>
                  近6个月均收入：<br>{{ boardData.incomeLastSixMonths }}元
                </span>
              </div>
              <div class="cus-data-content-foot-mb"  style="margin-top: 23pt;">
                <div class="cus-data-content-describe-mb">
                  个人客户主要是工资，小微商户主要是收单收入，近3个月和6个月不包括转账
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col  span="8">
          <div class="cus-data-mb">
            <div class="cus-data-title-mb cus-data-title-bg1-mb" >
              客户资产
            </div>
            <div class="cus-data-content-mb">
              <div class="cus-data-content-data-mb">
                <span class="data-span-mb">
                  稳定性评级:{{ boardData.assetDataStabilityRating }}<br>
                  日均资产:<br>{{ homeStat.summary_metrics.assetDayAvg }}元<br>
                  近3个月日均:<br>{{ boardData.assetDataThreeMonthDayAvg }}元<br>
                  近6个月日均:<br>{{ boardData.assetDataSixMonthDayAvg }}元<br>
                </span>
              </div>
              <div class="cus-data-content-foot-mb" >
                <div class="cus-data-content-describe-mb">
                  提供客户的银行卡余额日均情况，辅助证明客户的日常资产是否能否覆盖贷款额
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    dataMap: Object,
    homeStat: Object,
    score: Object,
    boardData: Object
  },
  data () {
    return {
      gutter: 52
    }
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>
<style>

.ivu-table td {
  background-color: #F5F5F5;
}
.board-mb {
  width: 100%;
}
.cus-data-mb {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  box-shadow: 0pt 0pt 30pt 0pt rgba(0,0,0,0.06);
}
.cus-data-title-mb {
  width: 100%;
  height: 30pt;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 14pt;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cus-data-title-bg1-mb {
  background-image: url(../../../../assets/images/content-v4/board/cust-data-title1.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.cus-data-title-bg2-mb {
  background-image: url(../../../../assets/images/content-v4/board/cust-data-title2.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.cus-data-content-mb {
  width: 100%;
}
.cus-data-content-title-mb {
  margin-top: 28pt;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 24pt;
  color: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cus-data-content-line {
  margin-top: 15pt;
  display: flex;
  justify-content: center;
  align-items: center;
}
hr {
  border: 1pt solid #999999;
  width: 34pt;
}
.cus-data-content-data-mb {
  text-align: center;
}
.data-span-mb {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 10pt;
  color: #333333;
  line-height: 20pt;
}
.dvd-font-mb {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14pt;
  color: #666666;
}
.cus-data-content-describe-mb {
  text-align: center;
  font-family: Microsoft YaHei;
  font-size: 8pt;
  color: #999999;
  line-height: 15pt;
}
.cus-data-content-foot-mb {
  margin-top: 20pt;
  margin-bottom: 10pt;
}
</style>
